import { useEffect } from "react";

import { APP_TITLE } from "settings";

export const formatPageTitle = (title?: string) =>
  title ? `${title} | ${APP_TITLE}` : APP_TITLE;

/**
 * Refine the tab title set by the route (see `RouteTitle`) once a page knows
 * more, e.g. a case reference. Passing `undefined` leaves the route title.
 */
export default function usePageTitle(title?: string) {
  useEffect(() => {
    if (title) {
      document.title = formatPageTitle(title);
    }
  }, [title]);
}
